import React, { useEffect, createElement } from 'react';
export function TrackingScripts() {
  useEffect(() => {
    // Google Ads (AW-649210165)
    const gadsScript = document.createElement('script');
    gadsScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    gadsScript.async = true;
    document.head.appendChild(gadsScript);
    const gadsInline = document.createElement('script');
    gadsInline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
      gtag('config', 'G-LTTKB8L6K8');
    `;
    document.head.appendChild(gadsInline);
    // Meta Pixel (527906828002058)
    const metaPixel = document.createElement('script');
    metaPixel.textContent = `
      !function(f,b,e,v,n,t,s){
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init','527906828002058');
      fbq('track','PageView');
    `;
    document.head.appendChild(metaPixel);
    // Meta Pixel noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=527906828002058&ev=PageView&noscript=1" />';
    document.head.appendChild(noscript);
  }, []);
  return null;
}